module.exports = __webpack_public_path__ + "static/img/toplogo.92b42ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toplogo.png
// module id = wvmr
// module chunks = 16